/* Upload/download genérico de arquivo (backend /arquivos) -- substitui o
   Supabase Storage nas telas que só precisam de "enviar arquivo, guardar
   o caminho, abrir depois" (hoje: anexo de processo do Onboard;
   vencimentos de cliente tem seu próprio wrapper em services/vencimentos.js
   por já ter esse formato de retorno {url,nome,tipo} espalhado no código). */
import { API_URL, obterToken } from './apiClient';

export async function uploadArquivoGenerico(file, categoria) {
  const form = new FormData();
  form.append('arquivo', file);
  const token = obterToken();
  const response = await fetch(`${API_URL}/arquivos/upload?categoria=${encodeURIComponent(categoria)}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await response.json();
  if (!response.ok) throw new Error(json.error || 'Erro no upload');
  return json;
}

/* abre o arquivo numa aba nova -- a aba é aberta ANTES do fetch (síncrono,
   dentro do clique) pra não ser bloqueada como pop-up; o conteúdo só entra
   depois que o download autenticado terminar. */
export async function abrirArquivo(caminho) {
  const nova = window.open('', '_blank');
  try {
    const token = obterToken();
    const response = await fetch(`${API_URL}/arquivos/${caminho}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) {
      let mensagem = 'Erro ao abrir o documento';
      try { mensagem = (await response.json()).error || mensagem; } catch {}
      throw new Error(mensagem);
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    if (nova) nova.location.href = url;
  } catch (e) {
    if (nova) nova.close();
    throw e;
  }
}
